import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Box, Drawer, ListItem } from '@material-ui/core';
import { Field, Form } from 'react-final-form';
import { TextAreaComponent, DatePickerComponent, TextFieldWithSelectComponent } from '../../components/FormElement';
import Button from '../../components/ButtonCustom';
import { portalCfg } from '../../../portal.router.config';
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import {CheckIcon, ErrorIcon} from '../../components/icons'
import {Cancel} from '@material-ui/icons'
import Divider from '../../components/Divider'
import { getAppCfg } from '../../utils/common';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { custom_assets, domainName, portal_config } from '../../../portal.config';
import { isRetina } from '../../utils/util';
import CustomizedCircularProgress from '../../components/CircularProgress'
var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo  ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";
const referFriendImg = isRetina(path+"/images/refer_friend.svg", path+"/images/refer_friend.svg")
    const styles = theme => ({
        form: {
            marginTop: theme.spacing(4),
            backgroundColor: theme.palette.background.box,
            padding: theme.spacing(8, 4, 8, 4),
            borderRadius: theme.spacing(4),
        },
        button: {
            marginTop: theme.spacing(8)
        },
        marginTop:{
            marginTop: theme.spacing(4)
        },
        form2:{
            padding: theme.spacing(4),
            marginTop: theme.spacing(1.5),
            marginBottom: theme.spacing(1.5),
            border: '1px solid',
            borderColor: theme.palette.border.transparent,
            backgroundColor: theme.palette.background.secondary,
            borderRadius: theme.spacing(4),
            boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        },
});

function ReferFriendView(props) {
        
    const { classes, t, onSubmit, result, isValueNull,handleChange } = props
    const app_config = getAppCfg()
    var image =  app_config.creatives && app_config.creatives.length > 0 ? dataUtil.getImageByUsageTypePortal(app_config.creatives,usage_type.refer_friend) : referFriendImg
    let auth_support = app_config.auth_support;
    let isEmail = auth_support.email_password || auth_support.email_otp ? true : false;
    const referMethod = app_config.features && app_config.features.rewards_details && app_config.features.rewards_details.refer_friend_communication_method ? app_config.features.rewards_details.refer_friend_communication_method : null ;
    if(referMethod){
        isEmail = referMethod == "EMAIL" ? true : false;
    }
    var contact = props.contact;
    //console.log('app_config====',app_config)
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={() => props.handleDrawerOtherToggle('refer_friend')}
                title = {t('refer_a_friend')}
                children={
                    <Grid item >
                        <Grid xs={12} item container justify='center'>
                            <img src={image.url?image.url:image} style={{width: 360}}/>
                        </Grid>
                        <Grid xs={12} item container justify='center'>
                            <CustomTypo mg_top_xl color='onPrimary' variant='subtitle2'>{t('refer_a_friend_title')}</CustomTypo>
                        </Grid>
                        <Grid xs={12} item container justify='center'>
                            <CustomTypo mg_top_sm variant='body2' color='onPrimary' center>{t('refer_a_friend_desc')}{app_config.name ? app_config.name : portal_config[domainName].app_name}{t('refer_a_friend_desc2')}</CustomTypo>
                        </Grid>
                        <Grid xs={12} item container justify='center' style={{color: '#3498db'}}>
                            {props.loadingCode?<CustomizedCircularProgress/>:<CustomTypo mg_top_xl variant='caption1'>{contact.referral_code? t('referral_code2')+ ': '+ contact.referral_code:' '}</CustomTypo>}
                        </Grid>
                        <Form
                            onSubmit={onSubmit}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item justify='center' className={classes.form}>
                                    <Grid xs={12} item container>
                                        <CustomTypo color='primary' variant='body2'>{isEmail?t('refer_emails') : t('refer_phones')}</CustomTypo>
                                        <Field
                                            name="email"
                                            component={TextAreaComponent}
                                            //label={t('first_name')}
                                            placeholder={isEmail? t('refer_a_friend_email'):t('refer_a_friend_phone')}
                                            isEdit={true}
                                            color='default'
                                            isValueNull={isValueNull}
                                            onCustomChange={handleChange}
                                            multiline
                                        />
                                    </Grid>
            
                                    <Grid xs={12} item container justify='center' className={classes.button}>
                                        <Button color='primary' fullWidth onClick={handleSubmit}>{t('btn_submit')}</Button>
                                    </Grid>
                                </Grid>
                            )} />
            
                        {result && <Grid xs={12} item className={classes.form2}>
                            <CustomTypo variant='caption1' >{t('referred_friends')}</CustomTypo>
                            {result.valid && result.valid.map((element, index) => {
                                return (
                                        <Grid xs={12} item container className={classes.marginTop}>
                                            <Grid xs ={10} item>
                                                <CustomTypo  >{element}</CustomTypo>
                                            </Grid> 
                                            <Grid xs={2} item container justify='flex-end'>
                                                <CheckIcon />
                                            </Grid>
                                            <Grid xs={12} item className={classes.marginTop}>
                                                <Divider fullWidth/>
                                            </Grid>    
                                            </Grid>
                                        )
                            })}
                            {result.invalid && result.invalid.map((element, index) => {
                                return (
                                    <Grid xs={12} item container className={classes.marginTop}>
                                        <Grid xs ={10} item>
                                            <CustomTypo  >{element}</CustomTypo>
                                        </Grid> 
                                        <Grid xs={2} item container justify='flex-end'>
                                            <Cancel style={{ color: 'rgba(255,0,0,0.8)' }}/>
                                        </Grid>
                                        <Grid xs={12} item className={classes.marginTop}>
                                            <Divider fullWidth/>
                                    </Grid>    
                                    </Grid>
                                )
                    })}
                        </Grid>}     
                </Grid>}/>

        </div>
    )
}

export default withStyles(styles)(withTranslation()(ReferFriendView));